import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, AlertCircle } from "lucide-react";

export default function Cancel() {
  return (
    <div
      data-testid="cancel-page"
      className="min-h-screen bg-[#F4EBDE] flex items-center justify-center px-6 py-16"
    >
      <div className="bg-white rounded-[2rem] p-8 sm:p-10 md:p-14 max-w-xl w-full border border-[#E8DDC9] shadow-[0_20px_60px_rgba(42,48,42,0.06)] text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-[#C8A892]/20 flex items-center justify-center">
          <AlertCircle className="h-7 w-7 text-[#C8A892]" />
        </div>
        <h1 className="font-serif-display text-3xl md:text-4xl text-[#2A302A] mt-6">
          Compra cancelada
        </h1>
        <p className="text-[#576057] mt-4 leading-relaxed">
          No te preocupes — no se realizó ningún cargo. Puedes volver a intentar
          cuando quieras.
        </p>
        <Link
          to="/"
          data-testid="back-home-link"
          className="mt-10 inline-flex items-center gap-2 bg-[#849983] hover:bg-[#6F856E] text-white rounded-full px-6 py-3 font-semibold tracking-wider transition shadow-[0_8px_24px_rgba(132,153,131,0.3)]"
        >
          <ArrowLeft className="h-4 w-4" /> Volver al inicio
        </Link>
      </div>
    </div>
  );
}
